import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Challenge } from "../../models/challenge.model";

@Injectable()
export class ChallengeProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<Challenge> {
    return this.http
      .get<Challenge>(`${this.url}/challenges/${id}`)
      .map(response => {
        return new Challenge(response);
      })
      .catch(this.handleError)
  }

  getAll(): Observable<Challenge[]> {
    return this.http
      .get<Challenge[]>(`${this.url}/challenges`)
      .map(response => {
        return response.map((challenge) => new Challenge(challenge));
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/challenge/challenge.ts